import { useEffect, useCallback } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { useFormikContext } from '../Formik/forms'
import { ButtonConfig, useBookends } from 'lib/BookendsProvider'
import { useNotifications } from 'lib/NotificationsProvider'
import { isAllContract } from 'components/ContractSelector'
import { useCurrentUser } from 'lib/CurrentUserProvider'


export default function AllocationsTableFooter({permitSendIO, permitSave, contract, month, onCancel, refreshData, setOpenSendIOPreview}) {
  const { isSubmitting, dirty, submitForm, validateForm } = useFormikContext()

  const { setBookends } = useBookends()
  const { addNotification, clearNotifications } = useNotifications()
  const { currentUser } = useCurrentUser()


  // Running the validation first is to work around a Formik bug
  // https://github.com/jaredpalmer/formik/issues/1580
  // If Formik gets fixed to correctly reject submitForm this can change
  const validateAndSubmitForm = useCallback(async () => {
    const errors = await validateForm()
    if (Object.entries(errors).length === 0) {
      await submitForm()
      await refreshData()
      return true
    } else {
      return false
    }
  }, [refreshData, submitForm, validateForm])

  useEffect(() => {
    const buildClientButtons : () => ButtonConfig[] = () => {
      const monthText = month.format('MMMM YYYY')

      return [
        {
          type: 'primary',
          label: `Send ${monthText} IO`,
          onClick: () => setOpenSendIOPreview(true),
          disabled: dirty || isSubmitting || isAllContract(contract),
          sx: {
            width: 'max-content'
          },
          buttonProps: {
            startIcon: isSubmitting ? <CircularProgress size={20}/> : null,
          },
        },
        {
          type: 'menu',
          disabled: !dirty || isSubmitting || !permitSave,
          label: isSubmitting ? 'Please wait...' : 'Save',
          items: [
            { text: 'Save', onClick: () => {
              validateAndSubmitForm()
            }},
            { text: 'Save & Send IO', disabled: isAllContract(contract), onClick: () => {
              validateAndSubmitForm().then((success) => { if(success) { setOpenSendIOPreview(true) } })
            }}
          ],
        },
      ]
    }

    setBookends({
      footer: {
        buttons: [
          {
            type: 'secondary',
            label: 'Cancel',
            disabled: !dirty || isSubmitting,
            onClick: onCancel,
          },
          ...(permitSendIO ? buildClientButtons() : [
            {
              type: 'primary',
              label: 'Save',
              disabled: !dirty || isSubmitting || !permitSave,
              onClick: (() => {
                validateAndSubmitForm()
              })
            } as const,
          ]),
        ]
      }
    })
  }, [addNotification, clearNotifications, contract, dirty, permitSendIO, isSubmitting, month, onCancel, setBookends, submitForm, permitSave, validateAndSubmitForm, currentUser, setOpenSendIOPreview])

  return null
}
